import type { PaddleCredentials } from 'fitify-ui-onboarding/src/utils/paddle'

export const PADDLE_CREDENTIALS: PaddleCredentials = {
  environment: (process.env.NEXT_PUBLIC_PADDLE_ENVIRONMENT ||
    'sandbox') as PaddleCredentials['environment'],
  token: process.env.NEXT_PUBLIC_PADDLE_CLIENT_TOKEN || '',
}
